import { useAppStore } from '@/stores/useAppStore'
import { computed } from 'vue'

function legalUrls() {
  const appStore = useAppStore()
  const tosUrl = computed(() => appStore.tos.url)
  const privacyUrl = computed(() => appStore.privacy.url)
  return { tosUrl, privacyUrl }
}

export { legalUrls }
